import {ColumnCounter} from "./ColumnCounter";

export class FixedColumnCounter implements ColumnCounter {
    constructor(public readonly count: number) {
    }
}